<!-- START Sidebar (left)-->
<!--
  Menu agrupado por secciones (sidebar-sections.ts). Cada seccion tiene un titulo
  que pliega/despliega sus opciones (se guarda en preferencias) y los submenus se
  abren en acordeon debajo de su opcion. Con "Mantener menu colapsado" (Mas opciones)
  solo se ven los iconos y los submenus son flotantes.
  En telefonos y tablets (compacto) el mismo template es un panel flotante:
  perfil arriba y las opciones de cada seccion en cuadricula de 2 columnas.
  Estilos: sidebar.component.scss y layout.scss ("Layout compacto").
-->
<div class="aside-inner" role="navigation">
  <nav class="sidebar mt-0" [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')">
    <ul class="sidebar-nav sidebar-responsive w-100">
      <!-- Perfil: solo en compacto (en escritorio el usuario se muestra en el header) -->
      <li
        class="img-header-image sidebar-profile center only-compact"
        [class.c-pointer]="user && user.client"
        (click)="user && user.client ? Modal(profile, 'show') : ''"
      >
        <div class="center d-flex">
          <div class="center">
            <div
              class="d-flex gap-6 align-items-center animate__animated animate__fadeIn"
              *ngIf="user && user.user_type !== 0 && user.user_type !== -1"
            >
              <img
                [src]="validateImage(user)"
                class="rounded-circle"
                alt="client_logo"
                onerror="this.onerror=null;this.src='assets/img/dummy.png';"
              />
              <div class="d-flex flex-column">
                <div class="content-bussiness-name" *ngIf="user && user.client">
                  {{ user.client && user.client.name ? user.client.name : user.username }}
                </div>
                <small>{{ user.username }}</small>
              </div>
            </div>
            <ng-container *ngIf="user">
              <div class="center gap-6" *ngIf="user.user_type === 0 || user.user_type === -1">
                <div class="content-bussiness-name text-center">
                  {{ user.username }}
                  <div class="text-muted">
                    <small>{{ "sidebar.administrator" | translate }}</small>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </li>

      <ng-container *ngFor="let section of sections">
        <!-- Titulo de la seccion: pliega/despliega sus opciones -->
        <li
          *ngIf="section.key"
          class="nav-heading sidebar-section-title"
          [class.is-collapsed]="isSectionCollapsed(section.key)"
          (click)="toggleSection(section.key)"
        >
          <span>{{ section.key | translate }}</span>
          <i class="fa fa-minus section-toggle-icon" aria-hidden="true"></i>
        </li>

        <ng-container *ngIf="!isSectionCollapsed(section.key) || isCollapsedText()">
          <li
            *ngFor="let item of section.items"
            class="sidebar-item"
            [ngClass]="{ 'submenu-open': isSubmenuOpen(item) }"
            [routerLinkActive]="['active']"
          >
            <!-- Opcion simple -->
            <a
              href
              *ngIf="!item.submenu"
              [routerLink]="item.link"
              [attr.route]="item.link"
              title="{{ item.text | translate }}"
              [class]="item.available ? '' : 'disabled'"
              (mouseenter)="toggleSubmenuHover($event)"
            >
              <div [class]="item.available ? 'disabledTrue' : 'disabledTrue sb1'">
                {{ "sidebar.under-maintenance" | translate }}
                <i class="fa fa-wrench" aria-hidden="true"></i>
              </div>
              <div class="sidebar-item-content">
                <div class="sidebar-item-icon center">
                  <span
                    class="float-right"
                    *ngIf="item.alert"
                    [ngClass]="item.label || 'badge badge-success'"
                    >{{ item.alert }}
                  </span>
                  <em class="{{ item.icon }}" *ngIf="item.icon"></em>
                  <i
                    *ngIf="item.img"
                    class="fa menu-icon"
                    [ngStyle]="{
                      '-webkit-mask-image': 'url(../../../assets/menu-icons/' + item.img + ')'
                    }"
                  ></i>
                </div>
                <span *ngIf="!isCollapsedText()">{{ item.text | translate }}</span>
              </div>
            </a>
            <!-- Opcion con submenu: acordeon (o flotante con el menu colapsado) -->
            <a
              href
              *ngIf="item.submenu"
              (click)="onSubmenuClick($event, item)"
              title="{{ item.text | translate }}"
              [attr.aria-expanded]="isSubmenuOpen(item)"
              (mouseenter)="toggleSubmenuHover($event)"
            >
              <div class="sidebar-item-content">
                <div class="sidebar-item-icon center">
                  <span
                    class="float-right"
                    *ngIf="item.alert"
                    [ngClass]="item.label || 'badge badge-success'"
                    >{{ item.alert }}</span
                  >
                  <em class="{{ item.icon }}" *ngIf="item.icon"></em>
                  <i
                    *ngIf="item.img"
                    class="fa menu-icon"
                    [ngStyle]="{
                      '-webkit-mask-image': 'url(../../../assets/menu-icons/' + item.img + ')'
                    }"
                  ></i>
                </div>
                <span *ngIf="!isCollapsedText()">{{ item.text | translate }}</span>
                <i class="fa fa-angle-right submenu-chevron only-desktop" aria-hidden="true"></i>
              </div>
            </a>
            <!-- Submenu: debe ir justo despues del <a> (el flotante clona nextElementSibling) -->
            <ul *ngIf="item.submenu" class="sidebar-nav sidebar-subnav">
              <li class="sidebar-subnav-header">{{ item.text | translate }}</li>
              <li *ngFor="let subitem of item.submenu" [routerLinkActive]="['active']">
                <!-- Enlace externo -->
                <a
                  href
                  *ngIf="subitem.elink"
                  [attr.target]="subitem.target"
                  [attr.href]="subitem.elink"
                  title="{{ subitem.text | translate }}"
                >
                  <em class="{{ subitem.icon }}" *ngIf="subitem.icon"></em>
                  <span>{{ (subitem.text | translate) || subitem.text }}</span>
                </a>
                <!-- Opcion interna -->
                <a
                  href
                  *ngIf="!subitem.elink"
                  [routerLink]="subitem.link"
                  [attr.route]="subitem.link"
                  title="{{ subitem.text | translate }}"
                >
                  <div class="d-flex align-items-center">
                    <div class="sidebar-subitem-icon center">
                      <span
                        class="float-right"
                        *ngIf="subitem.alert"
                        [ngClass]="subitem.label || 'badge badge-success'"
                        >{{ subitem.alert }}</span
                      >
                      <em class="{{ subitem.icon }}" *ngIf="subitem.icon"></em>
                      <i
                        *ngIf="subitem.img"
                        class="fa menu-icon sm"
                        [ngStyle]="{
                          '-webkit-mask-image':
                            'url(../../../assets/menu-icons/' + subitem.img + ')'
                        }"
                      ></i>
                    </div>
                    <span>{{ (subitem.text | translate) || subitem.text }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </nav>
</div>
<!-- END Sidebar (left)-->

<!-- Modal perfil -->
<ng-template #profile style="top: 172px">
  <app-profile [user]="user" (submitProfile)="submitUser($event)"></app-profile>
</ng-template>
